import { useCallback, useRef } from "react";

type TNonceReturn = {
  updateNonce: () => number;
  getCurrentNonce: () => number;
};

const useNonce = (): TNonceReturn => {
  const nonceRef = useRef(0);

  const updateNonce = useCallback(() => {
    nonceRef.current += 1;
    return nonceRef.current;
  }, []);

  const getCurrentNonce = useCallback(() => nonceRef.current, []);

  return { updateNonce, getCurrentNonce };
};
export default useNonce;
